import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { ConfigService } from 'src/app/core/services/config/config.service';
import { HttphelperService } from 'src/app/core/services/helpers/httphelper.service';
import { BreadcrumbService } from 'src/app/core/services/navigation/breadcrumb.service';
import { ICallQueue } from 'src/app/models/icall-queue';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
  isLoading:boolean;
  paymentMethodSelected:any = null;
  displayPaymentView:boolean = false;
  apiPaymentUrl:string = "";
  constructor(private helperService:HttphelperService,private cd:ChangeDetectorRef,private translate: TranslateService,
    private messageService: MessageService,private router:Router,public breadSer:BreadcrumbService) { }

  ngOnInit(): void {
    if(this.breadSer.clinicTypeId == null || this.breadSer.clinicTypeId == undefined){
      this.router.navigate(['newrequest/category']);
      return;
    }
    this.paymentMethodSelected = this.breadSer.callQueue.PortalPaymentOption;
    if(this.paymentMethodSelected == 4){
      this.paymentMethodSelected = 2;
    }
  }
  async confirmPayment(){
    this.isLoading = true;
    this.apiPaymentUrl = "";
    this.displayPaymentView = false;
    let model :ICallQueue  =  
    {
      Id:0,
      AppointmentDate:this.breadSer.callQueue.AppointmentDate,
      AppointmentTime:this.breadSer.callQueue.AppointmentTime,
      ClinicID:this.breadSer.callQueue.ClinicID,
      MobileDoctorPath:this.breadSer.callQueue.MobileDoctorPath,
      PortalPaymentOption:this.paymentMethodSelected,
      ProviderID:this.breadSer.callQueue.ProviderID,
      ServiceId:this.breadSer.callQueue.ServiceId,
      PatientId: +localStorage.getItem('PatientId'),
      AppointmentDateNote:"",
      CreationDate:new Date(),
      AppointmentTimeNote:"",
      Comment:this.breadSer.callQueue.Comment,
      MultiAttachment:false,
      ImagePath:"",
      Area:"",
      IsEmergency:false,
      IsPayment:true,
      PatientName:"",
      RequestType:0,
      TimeZoneOffset:0
    };
    if(this.breadSer.uploadedFiles.length > 0)
    {
      var imageData:any = await this.getImageData(this.breadSer.uploadedFiles[0]);
      model.ImagePath =imageData.data.substring(imageData.data.indexOf("base64,") + 7);
      model.MultiAttachment = this.breadSer.uploadedFiles.length > 1 ? true : false;
    }
    var url = `/api/Queue/AddToQueue`;
    this.helperService.postRequest(url,true,model).subscribe(async response =>
    {
      if(response.Success)
      {
        if(model.MultiAttachment){
          for(var i=1; i<this.breadSer.uploadedFiles.length; i++){
            let index = 1;
            model.ImagePath = "";
            var imageData:any = await this.getImageData(this.breadSer.uploadedFiles[i]);
            model.Id = response.Id;
            model.ImagePath =imageData.data.substring(imageData.data.indexOf("base64,") + 7);
            this.helperService.postRequest(url,true,model).subscribe(res =>{
              if(index == this.breadSer.uploadedFiles.length -1){
                this.isLoading = false;
                if(this.paymentMethodSelected == 1 || this.paymentMethodSelected == 2){
                  this.handlePayment(res.RegisterObj);
                }else{
                  this.messageService.add({severity: 'success', summary: 'Success', detail:res.Message, life: 2000});
                  this.router.navigate(['/schedule']);
                }
              }
              index++;
            })
          }
        }
        else{
          this.isLoading = false;
          if(this.paymentMethodSelected == 1 || this.paymentMethodSelected == 2){
            this.handlePayment(response.RegisterObj);
          }else{
            this.messageService.add({severity: 'success', summary: 'Success', detail:response.Message, life: 2000});
            this.router.navigate(['/schedule']);
          }
        }
      }
      else
      {
        this.messageService.add({severity: 'warn', summary: 'Warn', detail:response.Message, life: 2000});
        this.isLoading = false;
      }   
    },
    error=>{
        this.messageService.add({severity: 'error', summary: 'Error', detail: error, life: 2000});
        this.isLoading = false;
    })
  }
  handlePayment(encryptedAccountService :string){
    this.displayPaymentView = true;
    this.apiPaymentUrl = ConfigService.APPMainsettings.MiclinicUrl + `/Billing/PaymentGatewayPage?token=${encryptedAccountService}&price=${this.breadSer.price}`;

  }
  async getImageData(file:any){
    return await this.readAsDataURL(file);
  }
  readAsDataURL(file :any) {
		return new Promise((resolve, reject)=>{
			let fileReader = new FileReader();
			fileReader.onload = function(){
				return resolve({data:fileReader.result.toString(), name:file.name, size: file.size, type: file.type});
			}
			fileReader.readAsDataURL(file);
		})
  } 
}
